<template>
    <div class="column-container d-flex order-lg-2 order-2 me-lg-auto">
        <OfferAmount />
    </div>

    <div v-if="offer?.apr_display?.formatted" class="column-container d-flex order-lg-3 order-3 me-lg-auto">
        <OfferRates />
    </div>

    <div class="column-container d-flex order-lg-4 order-4 me-lg-auto">
        <OfferTermCredit :show-label="showLabelOfferTermCredit" />
    </div>

    <div class="column-container d-flex order-lg-5 order-5 me-lg-auto">
        <OfferFees :show-fees-label="showLabelOfferFees" :show-term-label="showLabelOfferTermCredit" />
    </div>
</template>

<script>
export default {
    inject: ['offer'],
    computed: {
        showLabelOfferTermCredit: function () {
            return !this.offer.term_display || this.offer.term_display === '0'
        },
        showLabelOfferFees: function () {
            return !this.offer.fees || this.offer.fees === '0'
        },
    },
}
</script>
